
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import _ from "lodash-es";
import { Component, Vue } from "vue-property-decorator";
import NR, { CV } from "@/lib//model/NRXQ/nr";
import Auth from "../../../lib/common/auth";
import vuexStore from "../../../store/vuex-store";
import Upload from "../components/upload-cv.vue";
import AtsCv from "../components/ats-cv.vue";
import { NRRecommendPeople } from "../../../lib/model/NRXQ/candidate";
import { NRClientType } from "../../../lib/model/NRXQ/nr";
import request from "../../../lib/request/request";

@Component({
  components: { Upload, AtsCv }
})
export default class ListNr extends Vue {
  nrToken = "";
  data: any = {}; //表格所有数据
  tableData: NRRecommendPeople[] = []; //表格list数据
  page = 1;
  pageSize = 10;
  showDia = false;
  search = {
    positionType: 0
  };
  formData: any = {}; //上传简历数据
  CvData: any = {}; //解析后简历数据
  showWarn = false;
  showSuccess = false;
  copyMessageCotent = "";
  clientType = NRClientType.NRClientTypeAdmin;
  rules = {
    position: [{ required: true, message: "请输入应聘职位", trigger: "blur" }]
  };

  typeOptions: any = []; // 达人分类
  saleTypeOptions: any = []; //账号分类
  showContactDialog = false;
  isCustomSys = false; //客户端引用

  // 类目筛选器配置
  categoryFilterConfig = [
    {
      name: "带货分类",
      multi: true,
      key: "saleTypeList",
      options: []
    },
    {
      name: "账号分类",
      multi: true,
      key: "typeList",
      options: []
    }
  ];

  created() {
    this.nrToken = String(localStorage.getItem("nrToken") || "");
    this.isCustomSys = this.$route.name !== "nr-recommend";
    console.log(this.$route);
    this.getSearchCategoryList();
    this.getList();
  }

  mounted() {
    //
  }

  //联系方式
  contact(nr: NRRecommendPeople) {
    this.copyMessageCotent = `报告链接：${nr.candidateReportUrl}`;
    this.showContactDialog = true;
  }

  copyMessage() {
    const oInput = document.createElement("textarea");
    oInput.value = this.copyMessageCotent;
    document.body.appendChild(oInput);
    oInput.select();
    document.execCommand("Copy");
    oInput.style.display = "none";
    document.body.removeChild(oInput);
    this.$message.success("复制成功");
  }

  // 清空搜索类目
  clearSearchCategory(categoryType = "typeList") {
    delete this.search[categoryType];
    // 把该类目下所有checkbox都取消选中
    for (const item of categoryType === "typeList"
      ? this.typeOptions
      : this.saleTypeOptions) {
      item.checked = false;
      if (item.children) {
        for (const subItem of item.children) {
          subItem.checked = false;
        }
      }
    }
    this.$forceUpdate();
    this.getList();
  }

  // 点击了类目按钮
  onMainCategoryBtnClicked(
    categoryType = "typeList",
    value: any[],
    isSingle = true
  ) {
    if (!this.getMainCategorySelected(categoryType, value[0])) {
      // 该类目不在筛选中，加入筛选
      if (isSingle || !this.search[categoryType])
        this.search[categoryType] = [];

      this.search[categoryType].push(value);
    } else {
      // 该类目已在筛选中，取消筛选
      this.search[categoryType] = this.search[categoryType].filter(
        (item: any) => {
          return item[0] != value[0];
        }
      );

      // 把该类目下所有checkbox都取消选中
      for (const item of categoryType === "typeList"
        ? this.typeOptions
        : this.saleTypeOptions) {
        if (item.value === value[0]) {
          item.checked = false;
          if (item.children) {
            for (const subItem of item.children) {
              subItem.checked = false;
            }
          }
          break;
        }
      }
    }

    console.log(this.search);
    this.$forceUpdate();
    this.getList();
  }

  // 点击了类目下拉单选项 (单选）
  onSubCategoryDropDownChange(
    categoryType: string,
    item: any,
    subItemName: string
  ) {
    for (const subItem of item.children) {
      if (subItem.value === subItemName) {
        subItem.checked = !subItem.checked;
        if (subItem.checked)
          this.search[categoryType] = [[item.value, subItemName]];
        else this.search[categoryType] = [];
      } else {
        subItem.checked = false;
      }
    }

    this.$forceUpdate();
    this.getList();
  }

  // 点击了类目下拉多选项 （多选）
  onSubCategoryCheckBoxChange(
    categoryType: string,
    optionItem: any,
    event: any
  ) {
    // 取消筛选
    if (this.search[categoryType]) {
      this.search[categoryType] = this.search[categoryType].filter(
        (item: any) => {
          return item[0] != optionItem.value;
        }
      );
    } else {
      this.search[categoryType] = [];
    }

    for (const subItem of optionItem.children) {
      if (subItem.checked) {
        this.search[categoryType].push([optionItem.value, subItem.value]);
      }
    }
    this.$forceUpdate();
    this.getList();
  }

  //获取检查类目当前选中状态
  getMainCategorySelected(categoryType = "typeList", value: string) {
    if (!this.search[categoryType]) return false;
    for (const item of this.search[categoryType]) {
      console.log(item[0], value);
      if (item[0] === value) return true;
    }
    return false;
  }

  getSearchCategoryList() {
    request.post("aiExam/atsPublic/typeOptions").then((res: any) => {
      if (res.data.code == 0) {
        const typeOptions = [];
        const saleTypeOptions = [];
        //组装账号分类
        for (const index in res.data.data.typeOptions.keyList1) {
          const item = {
            value: res.data.data.typeOptions.keyList1[index],
            label: res.data.data.typeOptions.keyList1[index],
            children: []
          };

          const children: any[] = [];
          for (const subOriItem of res.data.data.typeOptions.keyList2[index]) {
            const subItem = {
              value: subOriItem,
              label: subOriItem
            };
            children.push(subItem);
          }
          if (children.length > 0) (item.children as any) = children;
          else delete item.children;
          typeOptions.push(item);
          this.typeOptions = typeOptions;
          (this.categoryFilterConfig[1] as any).options = this.typeOptions;
        }
        //组装带货分类
        for (const index in res.data.data.saleTypeOptions.keyList1) {
          const item = {
            value: res.data.data.saleTypeOptions.keyList1[index],
            label: res.data.data.saleTypeOptions.keyList1[index],
            children: []
          };

          const children: any[] = [];
          for (const subOriItem of res.data.data.saleTypeOptions.keyList2[
            index
          ]) {
            const subItem = {
              value: subOriItem,
              label: subOriItem
            };
            children.push(subItem);
          }
          if (children.length > 0) (item.children as any) = children;
          else delete item.children;
          saleTypeOptions.push(item);
          this.saleTypeOptions = saleTypeOptions;
          (this.categoryFilterConfig[0] as any).options = this.saleTypeOptions;
        }
      }
    });
  }

  async getList(page = this.page) {
    const param = {
      page: page,
      pageSize: this.pageSize,
      atsUserToken: this.nrToken
    };
    _.assign(param, this.search);
    //ats端 或 客户端
    const res = this.isCustomSys
      ? await NRRecommendPeople.customList(param)
      : await NRRecommendPeople.list(param);
    if (res.data.code !== 0) return;
    this.data = res.data.data;
    const tableData = [];
    for (const item of this.data.list) {
      tableData.push(new NRRecommendPeople().assign(item));
    }
    this.tableData = tableData;
    console.log(this.tableData);
  }

  openUp() {
    this.showSuccess = false;
    this.showWarn = false;
    this.formData = { position: "" };
    this.showDia = true;
  }

  showDetail(row: any) {
    //this.cvId = row.atsCvId;
    //this.showCV = true;
    window.open(row.candidateReportUrl);
  }

  submit() {
    (this.$refs["form"] as any)?.validate(async (valid: any) => {
      if (valid) {
        //创建简历
        const p = this.CvData;
        p.atsUserToken = this.nrToken;
        p.position = this.formData.position;
        CV.saveCV(p).then(res => {
          this.$message.success("保存成功");
          this.close();
          this.getList();
        });
      }
    });
  }

  get beforeUpload() {
    return (
      this.formData.position !== "" && this.formData.position !== undefined
    );
  }

  getSalesTypeShowText(item: any) {
    if (item.saleType && item.saleType.length > 0 && item.saleType[0]) {
      return (
        `${item.saleType[0]}` +
        (item.saleType[0] &&
        item.saleType[0] != "不带货" &&
        item.saleType.length > 1
          ? "/" + item.saleType[1]
          : "")
      );
    } else {
      return "-";
    }
  }

  //上传成功回调
  uploadSuccess(res: any) {
    this.showWarn = true;
    //解析简历
    CV.checkCV({
      resumeFileUrl: res.url,
      resumeFileName: res.filename,
      atsUserToken: this.nrToken
    }).then(res => {
      this.CvData = res;
      this.showSuccess = true;
      this.showWarn = false;
      this.$message.success("解析完成");
    });
  }

  close() {
    this.formData.name = "";
    this.showDia = false;
  }
}
